var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.236 17.8068C17.6816 18.2287 18.3848 18.2095 18.8068 17.7639C19.2287 17.3183 19.2095 16.6151 18.7639 16.1932L17.236 17.8068ZM9.24142 10.2372L17.236 17.8068L18.7639 16.1932L10.7693 8.62351L9.24142 10.2372Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0054 17.0027V9.51318H17.4949",
    stroke: "#FFF6F6",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7573 20.1874C22.3083 19.7692 21.6052 19.7942 21.187 20.2432C20.7687 20.6923 20.7937 21.3954 21.2428 21.8136L22.7573 20.1874ZM30.8909 27.7624L22.7573 20.1874L21.2428 21.8136L29.3764 29.3886L30.8909 27.7624Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1335 21.0027L30.1335 28.4922L22.644 28.4922",
    stroke: "#FFF6F6",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full_screen.77f0a8366fc53ec559bf5c9902332463.svg";
export { ForwardRef as ReactComponent };